import {
	canonical,
	capitalizeFirstLetter,
	generateBreadcrumbStructuredDataMarkup,
} from "@/common/functions";

export default function() {
	if (this.isError) {
		return {
			title: this.$t("WordscapesErrorPageMetaTitle"),
			meta: [
				{
					name: "description",
					content: this.$t("WordscapesErrorPageMetaDescription"),
				},
			],
		};
	}

	if (!this.groupInfo || !this.groupInfo.name) return {};

	const packs = Object.values(this.groupInfo.packs).slice(0, 3);
	const obj = packs.reduce((acc, item, index) => {
		acc[`LevelNumber_${index + 1}`] = `${item.min} - ${item.max}`;
		acc[`PackName_${index + 1}`] = capitalizeFirstLetter(item.name);
		return acc;
	}, {});
	return {
		title: this.$t("WordscapesGroupPageMetaTitle", {
			GroupName: capitalizeFirstLetter(this.groupInfo.name),
		}),
		meta: [
			{
				name: "description",
				content: this.$t("WordscapesGroupPageMetaDescription", {
					GroupName: capitalizeFirstLetter(this.groupInfo.name),
					...obj,
				}),
			},
		],
		script: [
			{
				type: "application/ld+json",
				json: generateBreadcrumbStructuredDataMarkup([
					{
						name: capitalizeFirstLetter(this.groupInfo.name),
						path: this.$route.path,
					},
				]),
			},
		],
		link: [canonical(this.$route)],
	};
}
